mutation CreateMailerConfig($input: CreateMailerConfigInput!) {
  createMailerConfig(input: $input) {
    id
  }
}
